import { debounce } from "lodash";
import React, { useCallback, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { setSearchText, setSearchType } from "../features/filter/filterSlice";

const Filters = ({ resetPagination }) => {
    const [input, setInput] = useState("");
    const [type, setType] = useState("all");
    const dispatch = useDispatch();

    //input debounce
    const handleSearchResult = useCallback(
        debounce((value) => {
            value?.length !== 0 && dispatch(setSearchText(value.toLowerCase()));
        }, 500),
        []
    );

    useEffect(() => {
        handleSearchResult(input);
    }, [input, handleSearchResult, dispatch]);

    return (
        <div className="filters">
            <input
                type="search"
                placeholder="search transactions"
                value={input}
                onChange={(e) => {
                    resetPagination();
                    setInput(e.target.value);
                    setType("all");
                    dispatch(setSearchType("all"));
                }}
            />
            <div className="filters_radio form-group radio">
                <div className="radio_group">
                    <input
                        required
                        type="radio"
                        value="all"
                        name="type"
                        checked={type === "all"}
                        onChange={(e) => {
                            resetPagination();
                            setType(e.target.value);
                            dispatch(setSearchType(e.target.value));
                        }}
                    />
                    <label>All</label>
                </div>
                <div className="radio_group">
                    <input
                        required
                        type="radio"
                        value="income"
                        name="type"
                        checked={type === "income"}
                        onChange={(e) => {
                            setInput("");
                            resetPagination();
                            setType(e.target.value);
                            dispatch(setSearchType(e.target.value));
                        }}
                    />
                    <label>Income</label>
                </div>
                <div className="radio_group">
                    <input
                        type="radio"
                        value="expense"
                        name="type"
                        placeholder="Expense"
                        checked={type === "expense"}
                        onChange={(e) => {
                            setInput("");
                            resetPagination();
                            setType(e.target.value);
                            dispatch(setSearchType(e.target.value));
                        }}
                    />
                    <label>Expense</label>
                </div>
            </div>
        </div>
    );
};

export default Filters;
